import { Badge } from "@/components/ui/badge.tsx";

export const StatusBadge = ({ status }: { status: string }) => (
  <Badge variant="secondary" className="text-xs font-medium uppercase">
    {status}
  </Badge>
);
